import React from 'react';

import { StickyHeaderLinksGradBlockData } from 'api/cms';
import { AmpLinksBlock } from 'cms/blocks/Amp/AmpLinksBlock';
import { AmpBlockMappingComponentProps } from 'cms/blocks/BlockMapping';

export function AmpStickyHeaderLinksGradBlock({
  data,
}: AmpBlockMappingComponentProps<StickyHeaderLinksGradBlockData>) {
  return <AmpLinksBlock data={{ ...data, isGrad: true }} />;
}
